import cx from 'classnames';
import * as React from 'react';

import Image from 'components/Image';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import OrganizationEngagementBadge from 'organizations/components/OrganizationEngagementBadge';

import { EngagementRating } from 'organizations/constants/EngagementRatings';

import './OrganizationEngagementBanner.scss';

type Props = {
  badgeAction: () => void;
  children: string;
  cta: string;
  eventKey: string;
  rating?: EngagementRating;
  theme?: 'dark' | 'light';
  title?: string;
  to: string;
};

export default function OrganizationEngagementBanner({
  badgeAction,
  children,
  cta,
  eventKey,
  rating,
  theme,
  title,
  to,
}: Props) {
  return (
    <div
      className={cx(
        'OrganizationEngagementBanner',
        theme && `OrganizationEngagementBanner--${theme}`
      )}>
      <MediaObject center>
        {rating ? (
          <OrganizationEngagementBadge rating={rating} size="small" onClick={badgeAction} />
        ) : (
          <Image
            src={require('assets/images/organizations/OrganizationEngagementBanner/light-bulb.svg')}
          />
        )}
        <Text align="left" element="div" size="small">
          <Row size="xsmall">
            <Text element="h3" uppercase weight="bold">
              {title}
            </Text>
          </Row>
          <Text element="p" size="small">
            {children}
          </Text>
          <Link
            href={to}
            target="_blank"
            weight="semibold"
            eventKey={eventKey}
            className={theme === 'dark' ? 'OrganizationEngagementView-link' : undefined}>
            {cta}
          </Link>
        </Text>
      </MediaObject>
    </div>
  );
}

OrganizationEngagementBanner.defaultProps = {
  theme: 'light',
  title: 'Tip',
};
